import { cond, equals } from 'ramda';
import { offerCodeEnum } from '@@viewEnums';

export const iconCotisation = cond([
  [equals(offerCodeEnum.INDIVIDUAL_HEALTH), () => 'basket'],
  [equals(offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION), () => 'calculator'],
  [equals(offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT), () => 'calculator']
]);

export const titleCotisation = cond([
  [equals(offerCodeEnum.INDIVIDUAL_HEALTH), () => 'Montant de votre devis'],
  [equals(offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION), () => 'Montant total cotisation'],
  [equals(offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT), () => 'Montant total cotisation']
]);

export const labelTotalAmountMonth = cond([
  [equals(offerCodeEnum.INDIVIDUAL_HEALTH), () => 'Montant cotisations mensuel TTC'],
  [equals(offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION), () => 'Montant cotisation'],
  [
    equals(offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT),
    () => 'Montant cotisations mensuel TTC'
  ]
]);

export const labelTotalAmountYear = cond([
  [equals(offerCodeEnum.INDIVIDUAL_HEALTH), () => 'Montant cotisations annuel TTC'],
  [equals(offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION), () => 'Cotisation annuelle TTC'],
  [
    equals(offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT),
    () => 'Montant cotisations annuel TTC'
  ]
]);
